import React, { useEffect, useMemo, useCallback, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert'
import Paper from '@material-ui/core/Paper'
import AppsumoPlans from 'components/account/AppsumoPlans'

import userSelectors from 'store/selectors/user'
import appsumoActions from 'store/modules/appsumo'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(4),
  },
  paddedRow: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }
}))

const AccountPaymentsAppsumo = ({

}) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const user = useSelector(userSelectors.data)

  useEffect(() => {
    dispatch(appsumoActions.loadPlans())
  }, [])

  return (
    <div className={ classes.root }>
      <Container maxWidth="md">
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper className={ classes.paper }>
              <Typography variant="h4" gutterBottom>
                Sumo-ling nocode
              </Typography>
              <div className={ classes.paddedRow }>
                <Alert severity="info">AppSumo account: <strong>{ user.appsumo_email }</strong></Alert>
              </div>
              <Typography gutterBottom variant="body1">
                Your AppSumo tier is shown below - you can change the tier by clicking the buttons below.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <AppsumoPlans />
        </Grid>
      </Grid>
    </div>
  )
}

export default AccountPaymentsAppsumo